export const sleep = async (timeInMillisecond = 200) => {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve(true);
		}, timeInMillisecond);
	});
};
